import { render, staticRenderFns } from "./trusteeship-dialog.vue?vue&type=template&id=614485c6"
import script from "./trusteeship-dialog.vue?vue&type=script&lang=js"
export * from "./trusteeship-dialog.vue?vue&type=script&lang=js"
import style0 from "./trusteeship-dialog.vue?vue&type=style&index=0&id=614485c6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports